import { render, staticRenderFns } from "./tab-other-skills.vue?vue&type=template&id=2405addc"
import script from "./tab-other-skills.vue?vue&type=script&lang=js"
export * from "./tab-other-skills.vue?vue&type=script&lang=js"
import style0 from "./tab-other-skills.vue?vue&type=style&index=0&id=2405addc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports